export default __webpack_public_path__ + "static/will_marling-af97419988dde239bddb7385e7a8a8d8.jpg";